/**
 * Algolia InstantSearch legacy URLs use query keys like:
 *   sv_sok[refinementList][remoteness][0]
 * Flat URLs use:
 *   remoteness=distans
 * This module maps namespaced keys to the flat attribute / well-known slot.
 */

export type ParsedAlgoliaUrlParam =
  | { kind: 'query' }
  | { kind: 'page' }
  | { kind: 'sort' }
  | { kind: 'refinement'; attribute: string }
  | { kind: 'other' };

const INDEX_PREFIX = '(?:en_search|fi_hae|sv_sok)';

/**
 * Parse a single query-string key from an Algolia-style URL.
 * Non-matching keys should be handled as plain (flat) parameters.
 */
export function parseAlgoliaNamespacedParamKey(key: string): ParsedAlgoliaUrlParam {
  if (!key || typeof key !== 'string') {
    return { kind: 'other' };
  }

  if (new RegExp(`^${INDEX_PREFIX}\\[query\\]$`, 'i').test(key)) {
    return { kind: 'query' };
  }
  if (new RegExp(`^${INDEX_PREFIX}\\[page\\]$`, 'i').test(key)) {
    return { kind: 'page' };
  }
  if (new RegExp(`^${INDEX_PREFIX}\\[sort\\]$`, 'i').test(key)) {
    return { kind: 'sort' };
  }

  const refinement = key.match(new RegExp(`^${INDEX_PREFIX}\\[refinementList\\]\\[([^\\]]+)\\]\\[\\d+\\]$`, 'i'));
  if (refinement?.[1]) {
    return { kind: 'refinement', attribute: refinement[1] };
  }

  return { kind: 'other' };
}
